
import NoteText from "../../../assets/outline/NoteText.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NoteTextIcon({ className, dataTestid = "NoteTextIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NoteText data-testid={dataTestid} className={classes} {...rest} />
  );
}
